import React from "react";
import PropTypes from "prop-types";
import HtmlLabel from "../HtmlLabel/HtmlLabel";
import Wrapper from "./FormControl.style";

const FormControl = ({
  className,
  label,
  labelTag,
  htmlFor,
  children,
  error,
  validated,
  style,
}) => {
  const addAllClasses = ["form-control"];
  if (validated) {
    addAllClasses.push("is-validated");
  }
  if (error) {
    addAllClasses.push("has-error");
  }
  if (className) {
    addAllClasses.push(className);
  }

  return (
    <Wrapper className={addAllClasses.join(" ")} style={style}>
      {label && (
        <HtmlLabel
          className="field-label"
          as={labelTag}
          htmlFor={htmlFor}
          content={label}
        />
      )}
      {children}
      {error && <div className="feedback">{error}</div>}
    </Wrapper>
  );
};

FormControl.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  labelTag: PropTypes.string,
  htmlFor: PropTypes.string,
  children: PropTypes.node,
  validated: PropTypes.any,
  error: PropTypes.any,
};

export default FormControl;
